import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Loader from "../../components/loader";
import NoData from "../../components/noData";
import { useNCallContext } from "../../context/ncall-context";
import { API } from "../../service/api";
import { currentTime, makeStamp, validTime } from "../../utils/timestamp";
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from "../../utils/toast";
import Select from "react-select";

import Modal from "../../components/modal/modal";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import {
  availableShifts,
  selectedDepartment,
  selectedEmployee,
  selectedShift,
} from "../../utils/helperSchedule";
import { useMemo } from "react";

const config = {
  title: "",
  handler: null,
};

const ClientSchedules = () => {
  const today = moment().format("YYYY-MM-DD");

  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("logged-in-as") == "admin") {
      navigate("/admin");
    }

    // Adding this code to clear the local storage if the scheduler variable is set to default values.
    const schedulerState = localStorage.getItem("scheduler");
    if (
      schedulerState === null ||
      schedulerState === "f4b7a1e0-5a2f-4a39-a548-1c7b993e1c13" ||
      schedulerState === "c69ad4b4-99d9-43ea-bb4b-f3cc762a9d12"
    ) {
      console.log(
        "Clearing the scheduler variable state and restarting the application. Value: ",
        schedulerState
      );
      showInfoToast("App is being updated. Please enter the code again.");

      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 3000);
    }
  }, []);

  const {
    state,
    openModal,
    setOpenModal,
    activeSchedules,
    getActiveSchedules,
    inprogressField,
    setInprogressField,
  } = useNCallContext();
  const { departments, shifts } = state;
  let eventStatus = "";
  const [filteredShifts, setFilterShifts] = useState(shifts);

  const employeeRef = useRef();
  const departmentRef = useRef();
  const noteRef = useRef();
  const shiftRef = useRef();
  const dateRef = useRef();
  const [employee, setEmployee] = useState("");

  // id for updation of schedules
  let _id = "";

  const getSelectedEmployee = (employeeName) => {
    const { employees } = state;

    if (employees.length === 0 || employeeName === "") return;

    // const emp = employees.find(
    //   // Don't remove this concatinated space it matters
    //   (employee) =>
    //     employee.Firstname + " " + employee.Lastname === employeeName
    // );

    return selectedEmployee(employees, employeeName);
  };

  const getSelectedShift = (id) => {
    if (shifts.length === 0) {
      return;
    }

    // const shift = filteredShifts?.find((item) => item.id === id);
    return selectedShift(shifts, id);
  };

  const options = useMemo(() => {
    return state.employees.map((employee) => ({
      label: employee.hasOwnProperty("Alias")
        ? employee.Alias
        : `${employee.Firstname} ${employee.Lastname}`,
      value: employee.hasOwnProperty("Alias")
        ? employee.Alias
        : `${employee.Firstname} ${employee.Lastname}`,
    }));
  }, [state.employees]);

  const getSecletedDepartments = (name) => {
    if (departments.length === 0 || name === "") return;
    name.trim();
    //const department = departments.find((item) => item.department === name);
    return selectedDepartment(departments, name);
  };

  useEffect(() => {
    localStorage.setItem("sort", JSON.stringify({ id: "date", desc: false }));
    getActiveSchedules();
  }, []);

  const handleDeleteBtnClk = async (schedule) => {
    if (schedule.scheduleStatus === "in-progress") {
      try {
        const res = await API.deleteInProgressSchedule(_id);
        if (res.error) {
          showErrorToast(res.error.message);
        } else {
          showSuccessToast(res.message);
        }
      } catch (error) {
        showErrorToast(error.message);
      }
    } else if (
      validTime(
        schedule.date,
        schedule.shifts.startTime,
        schedule.shifts.endTime
      )
    ) {
      const res = await API.deleteSchedule(schedule.id);
      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }
      getActiveSchedules();
    } else
      showInfoToast("You cannot delete schedules that has past date and time!");
  };
  const handleInprogressUpdateSchedule = async (e) => {
    if (_id === "") {
      return;
    }

    const submitter = e.nativeEvent.submitter.name;
    setOpenModal(false);
    setInprogressField(false);

    if (submitter === "save") {
      const _emp = e.target.elements["employee"].value;

      let emp = getSelectedEmployee(_emp);

      let paylaod = {
        employeeId: emp.ID,
        employeeName: _emp,
      };

      try {
        const res = await API.patchInProgressSchedule(_id, paylaod);
        if (res.error) {
          showErrorToast(res.message);
        } else {
          showSuccessToast(res.message);
        }
      } catch (error) {
        showErrorToast(error.message);
      }
    }
    if (submitter === "delete") {
      try {
        const res = await API.deleteInProgressSchedule(_id);
        if (res.error) {
          showErrorToast(res.message);
        } else {
          showSuccessToast(res.message);
        }
      } catch (error) {
        showErrorToast(error);
      }
    }
    getActiveSchedules();
  };
  const handleUpdateBtnClk = (schedule) => {
    const { employeeName, shortNote, date, shift_id } = schedule;
    _id = schedule.id;
    if (
      currentTime(
        schedule.date,
        schedule.shifts.startTime,
        schedule.shifts.endTime
      )
    ) {
      eventStatus = "in-progress";

      config.title = "Update In-progress Schedule";
      config.handler = handleInprogressUpdateSchedule;
      config.eventStatus = eventStatus;

      employeeRef.current = { value: employeeName, label: employeeName };
      console.log(employeeRef.current);
      departmentRef.current = schedule.Department.department;
      noteRef.current = shortNote;
      dateRef.current = date;
      shiftRef.current = shift_id;

      setInprogressField(true);
      setOpenModal(!openModal);
    } else if (
      validTime(
        schedule.date,
        schedule.shifts.startTime,
        schedule.shifts.endTime
      )
    ) {
      _id = schedule.id;

      config.title = "Update Schedule";
      config.handler = handleUpdateSchedule;
      config.eventStatus = "";

      employeeRef.current = { value: employeeName, label: employeeName };
      departmentRef.current = schedule.Department.department;
      noteRef.current = shortNote;
      dateRef.current = date;

      shiftRef.current = shift_id;
      setOpenModal(!openModal);
    } else
      showInfoToast("You cannot edit schedules that has past date and time!");
  };

  const handleUpdateSchedule = async () => {
    const department = getSecletedDepartments(departmentRef.current.value);

    let shft = getSelectedShift(shiftRef.current.value);

    let emp = getSelectedEmployee(
      employeeRef.current?.value ?? employeeRef.current?.props?.value?.value
    );

    let timestamp = {};
    if (shft) {
      timestamp = makeStamp(
        dateRef.current.value,
        shft.startTime,
        shft.endTime
      );
    }

    let data = {
      employeeName: employeeRef.current.value,
      department: departmentRef.current.value,
      shortNote: noteRef.current.value,
      date: dateRef.current.value,
      shift_id: shiftRef.current.value,
      startTime: timestamp.startTime,
      endTime: timestamp.endTime,
      department_id: department.id,
      employeeId: emp.ID,
    };
    try {
      const res = await API.putSchedule(_id, data);
      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }
    } catch (error) {
      showErrorToast(error.message);
    }
    getActiveSchedules();

    _id = "";
  };

  const handleShiftsFilter = () => {
    const _filteredShifts = availableShifts(shifts, dateRef.current.value);
    // shifts?.filter((shift) =>
    //   validTime(dateRef.current.value, shift?.startTime, shift?.endTime)
    // );
    setFilterShifts(_filteredShifts);
    shiftRef.current = filteredShifts[0].id;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Employee",
        accessor: "employeeName",
      },
      {
        Header: "Department",
        accessor: "Department.department",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Job Title",
        accessor: "shortNote",
      },
      {
        Header: "Start",
        accessor: "startTime",
        Cell: ({ value }) => {
          return (
            <div className="uppercase">
              {moment(value).format("YYYY-MM-DD hh:mm A")}
            </div>
          );
        },
      },
      {
        Header: "End",
        accessor: "endTime",
        Cell: ({ value }) => {
          return (
            <div className="uppercase">
              {moment(value).format("YYYY-MM-DD hh:mm A")}
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "scheduleStatus",
        Cell: ({ value }) => {
          if (value === "in-progress") {
            return <div className="text-green-500 uppercase">{value}</div>;
          } else {
            return <div className="text-yellow-500 uppercase">{value}</div>;
          }
        },
      },
    ],
    []
  );

  const actions = [
    {
      icon: PencilIcon,
      handler: handleUpdateBtnClk,
      styles: "w-5 h-5 text-green-500",
    },
    {
      icon: TrashIcon,
      handler: handleDeleteBtnClk,
      styles: "w-5 h-5 text-red-500",
    },
  ];

  if (state.loading) return <Loader />;

  return (
    <div className="">
      {openModal ? (
        <Modal config={config}>
          <div className="space-y-6 sm:space-y-5">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="employee"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Employee
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <Select
                  name="employee"
                  // value={employee}
                  ref={employeeRef}
                  defaultValue={employeeRef.current}
                  isSearchable={true}
                  onChange={(option) => {
                    employeeRef.current = option;
                  }}
                  // value={employeeRef.current}
                  options={options}
                  className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                />
              </div>
              {/* <div className="mt-1 sm:col-span-2 sm:mt-0">
                <select
                  ref={employeeRef}
                  required
                  defaultValue={employeeRef.current}
                  id="employee"
                  name="employee"
                  className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                >
                  {state?.employees.map((option, index) => (
                    <option
                      value={option.Firstname + " " + option.Lastname}
                      key={option.id + "emp" + index}
                    >
                      {option.Firstname + " " + option.Lastname}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="department"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Department
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <select
                  ref={departmentRef}
                  required
                  disabled={inprogressField}
                  defaultValue={departmentRef.current}
                  name="department"
                  className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                >
                  {state?.departments.map((option, index) => (
                    <option
                      value={option.department}
                      key={option.id + "dept" + index}
                    >
                      {option.department}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="shift"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Shift
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <select
                  ref={shiftRef}
                  required
                  disabled={inprogressField}
                  defaultValue={shiftRef.current}
                  onFocus={handleShiftsFilter}
                  onChange={(e) => {
                    shiftRef.current = e.currentTarget.value;
                  }}
                  id="shift"
                  name="shift"
                  className="block uppercase w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                >
                  {filteredShifts.length === 0 ? (
                    <option
                      className=" capitalize"
                      key={`shift-not-available`}
                      disabled
                      value="No Shifts Avaiable"
                    >
                      No Shifts Avaiable
                    </option>
                  ) : (
                    filteredShifts?.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.startTime + "-" + option.endTime}
                      </option>
                    ))
                  )}
                </select>
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="start"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Date
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <input
                  ref={dateRef}
                  required
                  disabled
                  defaultValue={dateRef.current}
                  name="start"
                  type="date"
                  min={today}
                  onChange={handleShiftsFilter}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Select date"
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="note"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Job Title
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <textarea
                  ref={noteRef}
                  required
                  disabled={inprogressField}
                  defaultValue={noteRef.current}
                  type="text"
                  name="note"
                  id="note"
                  className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                />
              </div>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}

      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Schedules
          </h1>
        </div>
      </div>
      {!state.loading && activeSchedules.length === 0 ? (
        <NoData message={"You don't have any schedules."} />
      ) : (
        <div className="mt-8 flow-root">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <Table
                columns={columns}
                data={activeSchedules}
                // actions={actions}
                actions={
                  localStorage.getItem("scheduler") ===
                  "f4b7a1e0-4a39-a548-1c7b993e1c13-5a2f"
                    ? actions
                    : []
                }
                name="schedules"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientSchedules;
